import { Box, HStack, VStack } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";

export default function AdminLayout() {

  return (
      <VStack width={"100%"} height="100vh" gap={0} align="stretch">

        {/* Main Content ~ */}
          <HStack flex="1" gap={0} align="stretch" overflow="hidden">
            
            {/* Sidebar ~ */}
              <SideBar />
            {/* ~ Sidebar */}

            {/* Content ~ */}
            
              <Box as="main" flex="1" overflowY="auto" overflowX="auto">
                <Outlet />
              </Box>
            {/* ~ Content */}

          </HStack>
        {/* ~ Main Content */}

      </VStack>
  );
}
